var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0542 10.9936C11.7613 10.7007 11.2864 10.7007 10.9935 10.9936C10.7006 11.2864 10.7006 11.7613 10.9935 12.0542L12.0542 10.9936ZM13.4697 14.5304C13.7626 14.8233 14.2374 14.8233 14.5303 14.5304C14.8232 14.2375 14.8232 13.7626 14.5303 13.4697L13.4697 14.5304ZM10.9935 12.0542L13.4697 14.5304L14.5303 13.4697L12.0542 10.9936L10.9935 12.0542ZM6.57144 11.3929C3.90863 11.3929 1.75 9.23425 1.75 6.57144H0.25C0.25 10.0627 3.0802 12.8929 6.57144 12.8929V11.3929ZM11.3929 6.57144C11.3929 9.23425 9.23425 11.3929 6.57144 11.3929V12.8929C10.0627 12.8929 12.8929 10.0627 12.8929 6.57144H11.3929ZM6.57144 1.75C9.23425 1.75 11.3929 3.90863 11.3929 6.57144H12.8929C12.8929 3.0802 10.0627 0.25 6.57144 0.25V1.75ZM6.57144 0.25C3.0802 0.25 0.25 3.0802 0.25 6.57144H1.75C1.75 3.90863 3.90863 1.75 6.57144 1.75V0.25Z",
    fill: "#35d269"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlack);
export default __webpack_public_path__ + "static/media/search-black.d2089a862f6fe0e9cabd7c0a04fa5553.svg";
export { ForwardRef as ReactComponent };